import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "20",
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 6.25C12 5.83579 11.7172 5.5 11.3684 5.5H4.63158L4.54588 5.50685C4.2376 5.55651 4 5.8703 4 6.25C4 6.66421 4.28277 7 4.63158 7H11.3684L11.4541 6.99315C11.7624 6.94349 12 6.6297 12 6.25Z",
      fill: "#252729"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.3684 9.2C11.7172 9.2 12 9.53579 12 9.95C12 10.3297 11.7624 10.6435 11.4541 10.6932L11.3684 10.7H4.63158C4.28277 10.7 4 10.3642 4 9.95C4 9.5703 4.2376 9.25651 4.54588 9.20685L4.63158 9.2H11.3684Z",
      fill: "#252729"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 13.65C12 13.2358 11.7172 12.9 11.3684 12.9H4.63158L4.54588 12.9068C4.2376 12.9565 4 13.2703 4 13.65C4 14.0642 4.28277 14.4 4.63158 14.4H11.3684L11.4541 14.3932C11.7624 14.3435 12 14.0297 12 13.65Z",
      fill: "#252729"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 0.5C15.5523 0.5 16 0.947715 16 1.5V18.5C16 19.0523 15.5523 19.5 15 19.5H1C0.447715 19.5 0 19.0523 0 18.5V4.87812C0 4.57956 0.111291 4.29173 0.312136 4.07084L3.26131 0.827268C3.45083 0.618829 3.71948 0.5 4.0012 0.5H15ZM14.5 2H4.222L1.5 4.992V18H14.5V2Z",
      fill: "#252729"
    }, null, -1)
  ]))]))
}
export default { render: render }